export class HeaderButton {

    public type: number;
    public label: string;
    public color: string;
    public fontColor: string;
    public icon: string;
    public size: string;
    public borderColor: string;
    public fontSize: string;
    public callback: (item: unknown) => void;
    public shadow: boolean;

    constructor(
        type: number,
        label: string,
        color: string,
        fontColor: string,
        borderColor: string,
        fontSize: string,
        icon: string,
        size: string,
        callback: (item: unknown) => void,
        shadow?: boolean) {
        this.type = type;
        this.label = label;
        this.color = color;
        this.fontColor = fontColor;
        this.fontSize = fontSize;
        this.borderColor = borderColor;
        this.icon = icon;
        this.size = size;
        this.callback = callback;
        if (shadow) {
            this.shadow = shadow;
        } else {
            this.shadow = false;
        }
    }
}